import {gql} from "@irati/utils/gql"
import fullUnauthedBusinessV4 from "@irati/identity/services/fragments/fullUnauthedBusinessV4"
import fullUnauthedTenant from "@irati/identity/services/fragments/fullUnauthedTenant"
import fullBranding from "@irati/brand/services/fragments/fullBranding"

const query = gql`
  query ResumeUnauthedSessionV4($subdomain: String!) {
    unauthedBusiness: businessBySubdomain(subdomain: $subdomain) {
      ...fullUnauthedBusiness
    }
    branding: brandingBySubdomain(subdomain: $subdomain) {
      ...fullBranding
    }
    userTenant: businessBySubdomain(subdomain: $subdomain) {
      ...fullUnauthedTenant
    }
  }
  ${fullBranding}
  ${fullUnauthedTenant}
  ${fullUnauthedBusinessV4}
`

export const toString = query.loc.source.body

export default query
